module.exports = __webpack_public_path__ + "img/furniture_market.cf0b6334.png";